import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-auth-callback',
  template: `
    <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
      <div class="text-center">
        @if (!error) {
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Processing authentication…</span>
          </div>
          <p class="text-muted">Processing authentication…</p>
        }
        @if (error) {
          <div class="alert alert-danger">
            <strong>Authentication failed:</strong> {{ error }}
          </div>
          <a routerLink="/" class="btn btn-primary mt-2">Return to app</a>
        }
      </div>
    </div>
  `
})
export class AuthCallbackComponent implements OnInit {
  error = '';

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const errorParam = params.get('error');

    if (errorParam) {
      this.error = errorParam;
      return;
    }

    if (!code) {
      this.error = 'No authorization code received.';
      return;
    }

    try {
      await this.auth.handleCallback(code);
      this.router.navigate(['/']);
    } catch (err: any) {
      this.error = err.message || 'Token exchange failed.';
    }
  }
}
